import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { MatListModule } from '@angular/material/list';
import { RouteReuseStrategy, RouterModule } from '@angular/router';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { DetailServicePointModalComponent } from './detail-service-point-modal/detail-service-point-modal.component';
import { DetailServicePointComponent } from './detail-service-point/detail-service-point.component';
import { ErrorModalComponent } from './error-modal/error-modal.component';
import { FootComponent } from './foot/foot.component';
import { HeadboardComponent } from './headboard/headboard.component';
import { LoadModalComponent } from './load-modal/load-modal.component';
import { MessageModalComponent } from './message-modal/message-modal.component';
import { RetrySearchComponent } from './retry-search/retry-search.component';
import { ServicePointComponent } from './service-point/service-point.component';
import { ExpeditionsService } from './services/expeditions.service';
import { HttpInterceptorService } from './services/http-interceptor.service';
import { RatingsService } from './services/ratings.service';
import { SesionService } from './services/sesion.service';
import { ShipmentChangesService } from './services/shipment-changes/shipment-changes.service';
import { TrackingComponent } from './tracking/tracking.component';

import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { BannerComponent } from './banner/banner.component';
import { CustomizeMaskDirective } from './directives/customize-mask.directive';
import { FocusDirective } from './directives/focus.directive';
import { LocationDirective } from './directives/location.directive';
import { NgFormDirective } from './directives/ng-form.directive';
import { NgModelDirective } from './directives/ng-model.directive';
import { RegexReplaceDirective } from './directives/regex-replace.directive';
import { StreetWithNumberDirective } from './directives/street-with-number.directive';
import { StreetDirective } from './directives/street.directive';
import { ZipCodeDirective } from './directives/zip-code.directive';
import { ExpeditionChangesRouteReuseStrategy } from './expedition-changes-route-reuse-strategy';
import { MultiplePiecesModalComponent } from './multiple-pieces-modal/multiple-pieces-modal.component';
import { NumberConflictModalComponent } from './number-conflict-modal/number-conflict-modal.component';
import { PackageTrackingModalComponent } from './package-tracking-modal/package-tracking-modal.component';
import { BannerService } from './services/banner.service';
import { BlobErrorHttpInterceptor } from './services/blob-error-http-interceptor-service';
import { EgonService } from './services/egon.service';
import { LanguageInterceptorService } from './services/language-interceptor.service';
import { LoadIndicatorInterceptorService } from './services/load-indicator-interceptor.service';

@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    FormsModule,
    HttpClientModule,
    TranslateModule,
    TypeaheadModule.forRoot(),
    CollapseModule.forRoot(),
    BsDropdownModule.forRoot(),
    ModalModule.forRoot(),
    TooltipModule.forRoot(),
    NgxMaskDirective,
    NgSelectModule,
    NgScrollbarModule,
    MatDividerModule,
    MatListModule
  ],
  declarations: [
    HeadboardComponent,
    FootComponent,
    ServicePointComponent,
    ErrorModalComponent,
    LoadModalComponent,
    DetailServicePointComponent,
    DetailServicePointModalComponent,
    RetrySearchComponent,
    TrackingComponent,
    MessageModalComponent,
    FocusDirective,
    RegexReplaceDirective,
    PackageTrackingModalComponent,
    ZipCodeDirective,
    NgModelDirective,
    BannerComponent,
    NgFormDirective,
    LocationDirective,
    NumberConflictModalComponent,
    MultiplePiecesModalComponent,
    StreetDirective,
    StreetWithNumberDirective,
    CustomizeMaskDirective,
  ],
  exports: [
    TranslateModule,
    RouterModule,
    CommonModule,
    BsDropdownModule,
    HeadboardComponent,
    FootComponent,
    ServicePointComponent,
    DetailServicePointComponent,
    RetrySearchComponent,
    TrackingComponent,
    FocusDirective,
    RegexReplaceDirective,
    ZipCodeDirective,
    NgModelDirective,
    NgFormDirective,
    BannerComponent,
    LocationDirective,
    StreetDirective,
    StreetWithNumberDirective,
    CustomizeMaskDirective,
    MatDividerModule,
    MatListModule
  ]
})
export class ComunModule {
  static forRoot(): ModuleWithProviders<ComunModule> {
    return {
      ngModule: ComunModule,
      providers: [SesionService,
        ShipmentChangesService,
        ExpeditionsService,
        BannerService,
        RatingsService,
        {
          provide: HTTP_INTERCEPTORS,
          useClass: HttpInterceptorService,
          multi: true,
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: LanguageInterceptorService,
          multi: true,
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: LoadIndicatorInterceptorService,
          multi: true,
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: BlobErrorHttpInterceptor,
          multi: true
        },
        EgonService,
        provideNgxMask(),
        { provide: RouteReuseStrategy, useClass: ExpeditionChangesRouteReuseStrategy },
      ]
    };
  }
}
